import * as jsxRuntime from "/home/zxfz/jenkins/workspace/geo-client-prod/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment